export default __webpack_public_path__ + "static/media/HeroPoster.2fce3e3c.png";